import { useQueryClient } from "@tanstack/react-query";
import { useTRPC } from "../../lib/api";

/** Refreshes everything that shows a workspace after a change to it. */
export function useRefreshWorkspace(workspaceId: string) {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  return () =>
    Promise.all([
      queryClient.invalidateQueries({ queryKey: trpc.me.queryKey() }),
      queryClient.invalidateQueries({ queryKey: trpc.workspaces.get.queryKey({ workspaceId }) }),
      queryClient.invalidateQueries({ queryKey: trpc.workspaces.members.queryKey({ workspaceId }) }),
    ]);
}
